import { useAppSelector } from "@/lib/hooks";
import { ReactElement, useEffect, useState } from "react";
import { ISubSystemType } from "@/lib/interfaces";
import { Flex, Text } from "@chakra-ui/react";
import { Loader } from "../utils/Loader";
import DashboardLayout from "./DashboardLayout";
import { BiErrorCircle } from "react-icons/bi";
import { isEmpty } from "lodash";

type Props = {
    children: ReactElement;
    subSystem: ISubSystemType;
    subSystems?: ISubSystemType[];
}

const ModuleAccess = ({ children, subSystem, subSystems = [] }: Props) => {
    const { subsystems } = useAppSelector(state => state.apiData);
    const { client, building } = useAppSelector(state => state.apiData.favourite);
    const { loading, moduleAccessMap } = useAppSelector(state => state.apiData);
    const [canAccessModule, setCanAccessModule] = useState<boolean>(false);

    useEffect(() => {
        let canAccess = false;

        const contractIdsToIgnore = ['94031', '3236061']
        const accessMap = moduleAccessMap[client];

        if (!accessMap) {
            setCanAccessModule(false);
            return;
        }

        Object.keys(accessMap).map(contractId => {
            if (contractIdsToIgnore.includes(contractId)) return;

            //if building is in the contract?
            if (accessMap[contractId].buildings.includes(building)) {
                //now check 
                const checkSubystem = accessMap[contractId].subsystems?.find(sub => sub?.name === subSystem);

                if (checkSubystem) {
                    canAccess = true;
                } else {
                    if (canAccess === false)
                        canAccess = false;
                }
            } else {
                if (canAccess === false)
                    canAccess = false;
            }
        })
        setCanAccessModule(canAccess);
    }, [subSystem, subsystems, client, moduleAccessMap, building])

    if (
        loading.clients ||
        loading.contracts ||
        loading.buildings ||
        loading.subsystems ||
        loading.roles ||
        loading.privileges
    ) {
        return <Flex minH='100vh' justifyContent='center' alignItems='center' >
            <Flex direction='column'>
                <Loader />
                <Text fontSize='sm' fontWeight='bold'>Checking module availability...</Text>
            </Flex>
        </Flex>
    }

    if (isEmpty(moduleAccessMap)) {
        return <Flex minH='100vh' justifyContent='center' alignItems='center' >
            <Flex direction='column'>
                <Loader />
                <Text fontSize='sm' fontWeight='bold'>Checking module availability...</Text>
            </Flex>
        </Flex>
    }

    if (!canAccessModule && !isEmpty(moduleAccessMap)) {
        return <DashboardLayout>
            <Flex h='50px' p={5} alignItems='center' gap={2}>
                <BiErrorCircle size='30' color='red' />
                <Text fontSize='xl' fontWeight='500'>Module not available for selected building</Text>
            </Flex>
        </DashboardLayout>
    }

    return <>{children}</>
}

export default ModuleAccess;
